/* global ol */
'use strict'

import CloudDataConnector from './api.js'

export default class MargesGlaciairesMapController {
  constructor () {
    this.internal = {
      uiElements: {
        olMap: null,
        searchBar: null,
        loadingContainer: null,
        loadedContainer: null
      },
      allItems: [],
      selectedItems: [],
      mapVisibleItems: [],
      defaultPageLimit: 5,
      currentPageLimit: 5,
      currentPageLimitAllItems: 5,
      vectorBotanicalReportsSource: new ol.source.Vector({})
    }
  }

  wire () {
    if ($('#marges-glaciaires-container').length > 0) {
      $('#loadMoreButtonSelected, #loadMoreButtonAvailable').on('click', this, this.onLoadMoreButtonClicked)
      this.internal.uiElements.loadingContainer = $('#loading-container')
      this.internal.uiElements.loadedContainer = $('#loaded-container')
    }
    return this
  }

  load () {
    if ($('#marges-glaciaires-container').length > 0) {
      this.initMap()
      this.loadSearchIndex()
    }
  }

  initMap () {
    function styleText (text, color) {
      return {
        text: new ol.style.Text({
          font: 10 + 'px Arial',
          fill: new ol.style.Fill({
            color
          }),
          stroke: new ol.style.Stroke({
            color: '#000',
            width: 3
          }),
          textAlign: 'center',
          textBaseline: 'middle',
          text,
          overflow: true,
          scale: 1.75
        })
      }
    }

    function getBandVectorFromKml (kmlFilePath) {
      return new ol.layer.Vector({
        source: new ol.source.Vector({
          url: window.location.origin + '/' + kmlFilePath,
          format: new ol.format.KML({
            extractStyles: false
          })
        }),
        declutter: true,
        style: function (feature, resolution) {
          return new ol.style.Style({
            stroke: new ol.style.Stroke({
              color: feature.get('bandColor'),
              width: 3
            }),
            text: styleText(feature.get('band'), feature.get('textColor')).text
          })
        }
      })
    }

    const vectorPAGL = getBandVectorFromKml('open-layer-vectors/Tour_PAGL.kml')
    const vector1984 = getBandVectorFromKml('open-layer-vectors/Tour_1984L.kml')
    const vector2003 = getBandVectorFromKml('open-layer-vectors/Tour_2003L.kml')
    const vector2009 = getBandVectorFromKml('open-layer-vectors/Tour_2009L.kml')
    const vector2018 = getBandVectorFromKml('open-layer-vectors/Tour_2018L.kml')
    this.internal.uiElements.olMap = new ol.Map({
      target: 'marges-glaciaires-map',
      view: new ol.View({ center: ol.proj.fromLonLat([6.97, 46.0004333]), zoom: 14 }),
      layers: [
        new ol.layer.Tile({
          preload: 3,
          source: new ol.source.OSM({
            crossOrigin: null,
            url: 'https://tile.thunderforest.com/landscape/{z}/{x}/{y}.png?apikey=851c476fad9743cca9b16af9c72ecc05'
          })
        }),
        vectorPAGL,
        vector1984,
        vector2003,
        vector2009,
        vector2018,
        new ol.layer.Vector({
          source: this.internal.vectorBotanicalReportsSource,
          updateWhileAnimating: true,
          updateWhileInteracting: true
        })
      ],
      loadTilesWhileAnimating: true
    })

    // Wire map actions
    const that = this
    this.internal.uiElements.olMap.on('moveend', function (e) {
      that.onMapMoved(e, that)
    })
    this.internal.uiElements.olMap.on('pointermove', function (e) {
      that.onMapPointerMoved(e, that)
    })
    this.internal.uiElements.olMap.on('click', function (e) {
      that.onMapClicked(e, that)
    })
  }

  isInRange (item) {
    return parseFloat(item.latitude) > 45.66 &&
      parseFloat(item.latitude) < 46.24 &&
      parseFloat(item.longitude) > 6.34 &&
      parseFloat(item.longitude) < 7.39
  }

  drawMapElements () {
    let iconImgPath = null
    let zIndex = null
    let scale = null

    this.internal.vectorBotanicalReportsSource.clear()
    const botanicalReports = this.internal.allItems
    for (const botanicalReport of botanicalReports) {
      const iconFeature = new ol.Feature({
        geometry: new ol.geom.Point(ol.proj.transform([parseFloat(botanicalReport.longitude), parseFloat(botanicalReport.latitude)], 'EPSG:4326', 'EPSG:3857')),
        data: botanicalReport
      })
      iconFeature.setId(botanicalReport.botanical_report_id)

      iconImgPath = '/img/map/plants/'
      zIndex = 100

      if (this.internal.selectedItems.indexOf(botanicalReport) !== -1) {
        iconImgPath += 'selected/'
        zIndex = 300
      }

      if (botanicalReport.species.length >= 10) {
        scale = 1.5
        iconImgPath += 'leaf_map_pointer_3.png'
      } else if (botanicalReport.species.length >= 5) {
        scale = 1.3
        iconImgPath += 'leaf_map_pointer_2.png'
      } else if (botanicalReport.species.length >= 0) {
        scale = 1.1
        iconImgPath += 'leaf_map_pointer_1.png'
      } else {
        scale = 1
        iconImgPath += 'leaf_map_pointer_0.png'
      }

      const iconStyle = new ol.style.Style({
        image: new ol.style.Icon({
          // Anchor to the pin point at the bottom center of the icon
          anchor: [0.5, 1],
          anchorXUnits: 'fraction',
          anchorYUnits: 'fraction',
          scale,
          src: iconImgPath,
          crossOrigin: 'anonymous'
        }),
        zIndex
      })

      iconFeature.setStyle(iconStyle)
      this.internal.vectorBotanicalReportsSource.addFeature(iconFeature)
    }
  }

  drawLeftItems () {
    const selectedBotanicalReports = this.internal.selectedItems.slice(0, this.internal.currentPageLimit)

    if (this.internal.selectedItems.length > this.internal.currentPageLimit) {
      $('#loadMoreButtonSelected').removeClass('hidden')
    } else {
      $('#loadMoreButtonSelected').addClass('hidden')
    }

    // Called everytime, even if none item selected to ensure the re-render of the section
    $('#selectedBotanicalReportDrawArea').loadTemplate($('#searchResultBotanicalReportTemplate'), selectedBotanicalReports)
    $('#availableBotanicalReportDrawArea').loadTemplate($('#searchResultBotanicalReportTemplate'), this.internal.allItems.slice(0, this.internal.currentPageLimitAllItems))
    $('#availableBotanicalReportDrawArea .title').on('click', this, this.onResultItemClicked)

    // Selected items
    if (selectedBotanicalReports.length > 0) {
      $('#selectedTitle').removeClass('hidden')
    } else {
      $('#selectedTitle').addClass('hidden')
    }
  }

  updateVisibleItemsList () {
    const that = this
    // const searchWithMap = document.getElementById('search-map-input').checked
    // Construct list of visible itemp on map
    this.internal.mapVisibleItems = []
    this.internal.currentPageLimit = this.internal.defaultPageLimit
    const extent = this.internal.uiElements.olMap.getView().calculateExtent(this.internal.uiElements.olMap.getSize())
    this.internal.vectorBotanicalReportsSource.forEachFeatureInExtent(extent, function (feature) {
      const botanicalReport = that.internal.allItems.find((v) => {
        return v.id_botanical_report === feature.getId()
      })
      that.internal.mapVisibleItems.push(botanicalReport)
    })
  }

  async apiRefresh () {
    return new CloudDataConnector().getBotanicalReports()
  }

  loadSearchIndex () {
    // Use cached data
    const botanicalReportsCache = 'botanicalReports'
    if (localStorage.getItem(botanicalReportsCache)) {
      const cache = JSON.parse(localStorage.getItem(botanicalReportsCache))
      // tmp: Remove unwanted text
      cache[cache.findIndex(r => r.botanical_report_id === 'T76')].species = []
      this.apiDataChanged(cache)
    } else {
      // Synchronous API loading
      this.internal.uiElements.loadingContainer.removeClass('hidden')
      this.internal.uiElements.loadedContainer.addClass('hidden')
    }

    // In all cases, refresh data in background
    const that = this
    this.apiRefresh().then((botanicalReports) => {
      // tmp: Remove unwanted text
      botanicalReports[botanicalReports.findIndex(r => r.botanical_report_id === 'T76')].species = []

      localStorage.setItem(botanicalReportsCache, JSON.stringify(botanicalReports))
      that.internal.uiElements.loadingContainer.addClass('hidden')
      that.internal.uiElements.loadedContainer.removeClass('hidden')
      that.apiDataChanged(botanicalReports)
    })
  }

  reformatArrayString (data) {
    let formattedData = data
    if (Array.isArray(data)) {
      formattedData = data.join(', ')
    }
    return formattedData
  }

  apiDataChanged (botanicalReports) {
    for (const botanicalReport of botanicalReports) {
      if (this.isInRange(botanicalReport)) {
        botanicalReport.plantImgList = [
          '/img/map/plants/' + botanicalReport.band + '/1.jpg',
          '/img/map/plants/' + botanicalReport.band + '/2.jpg'
        ]
        botanicalReport.species = this.reformatArrayString(botanicalReport.species)
        this.internal.allItems.push(botanicalReport)
      }
    }
    this.drawMapElements()
    this.updateVisibleItemsList()
    this.drawLeftItems()
  }

  matchArrayAttribute (attributeArray, searchValue) {
    return attributeArray.some(attr => this.matchAttribute(attr, searchValue))
  }

  matchAttribute (attribute, searchValue) {
    if (typeof attribute === 'object' && Array.isArray(attribute)) {
      return this.matchArrayAttribute(attribute, searchValue)
    } else if (typeof attribute === 'string') {
      return attribute.trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').includes(searchValue)
    } else if (typeof attribute === 'number') {
      return this.matchAttribute(attribute.toString(), searchValue)
    } else {
      return false
    }
  }

  matchBotanicalReport (item, searchValue) {
    const botanicalReportAttributes = [
      'botanical_report_id',
      'band',
      'ice_free',
      'cont_time',
      'date',
      'altitude',
      'plant_cover',
      'diversity',
      'observations_mean_height',
      'productivity',
      'phanerophyte',
      'hemicryptophyte',
      'chamaephyte',
      'species'
    ]

    return botanicalReportAttributes.some(attr => this.matchAttribute(item[attr], searchValue))
  }

  onMapMoved (event, controller) {
    controller.updateVisibleItemsList()
    controller.drawLeftItems()
  }

  onMapPointerMoved (event, controller) {
    const pixel = controller.internal.uiElements.olMap.getEventPixel(event.originalEvent)
    const hit = controller.internal.uiElements.olMap.hasFeatureAtPixel(pixel)
    controller.internal.uiElements.olMap.getViewport().style.cursor = hit ? 'pointer' : ''
  }

  onMapClicked (event, controller) {
    const clickedIconFeature = controller.internal.uiElements.olMap.getFeaturesAtPixel(event.pixel)
    if (clickedIconFeature !== null && clickedIconFeature.length > 0) {
      // There may be a LOT of items because some botanicalReports are located at the same place
      // We will mark as "selected" all the corresponding ones
      controller.internal.selectedItems = []
      clickedIconFeature.forEach(item => {
        if (item.values_.data !== undefined) {
          // We clicked on an icon
          controller.internal.selectedItems.push(item.values_.data)
          $('#selectBotanicalReportBandDrawArea, #selectedBotanicalReportBandTitle').addClass('hidden')
        } else {
          const bandData = {
            name: item.values_.name,
            imgUrl: '/img/map/band/' + item.values_.band + '.jpg'
          }
          $('#selectBotanicalReportBandDrawArea').loadTemplate($('#selectBotanicalReportBandTemplate'), bandData)
          $('#selectBotanicalReportBandDrawArea, #selectedBotanicalReportBandTitle').removeClass('hidden')
        }
      })
      event.preventDefault()
      // Redraw items with selected colors
      controller.drawMapElements()
      controller.drawLeftItems()
    } else {
      controller.internal.selectedItems = []
      controller.drawMapElements()
      controller.drawLeftItems()
    }
  }

  onResultItemClicked (event) {
    const controller = event.data.internal

    const { id } = event.currentTarget.dataset
    const item = controller.allItems.find(item => item.botanical_report_id === id)
    controller.selectedItems = [item]
    event.data.drawMapElements()
    event.data.drawLeftItems()
  }

  onLoadMoreButtonClicked (item) {
    const { listType } = item.currentTarget.dataset
    if (listType === 'selected') { item.data.internal.currentPageLimit += 5 } else if (listType === 'all') { item.data.internal.currentPageLimitAllItems += 5 }

    item.data.drawLeftItems()
  }
}
